<template>
  <div id="data-list-list-view" class="data-list-container">

  <vx-card :title="$t('Filters')" class="mb-8" collapse-action>
  <div class="vx-row">
    
    <div class="vx-col lg:w-1/4 md:w-1/2 w-full mb-4">
      <label class="text-sm opacity-75">{{ $t("Search") }}</label>
      <vs-input 
        :placeholder="$t('TokenSerial')" 
        v-model="keySearch" 
        class="w-full mt-2" 
      />
    </div>

    <div class="vx-col lg:w-1/4 md:w-1/2 w-full mb-4">
      <label class="text-sm opacity-75">{{ $t("Opportunity") }}</label>
      <vs-select 
        class="w-full mt-2" 
        :placeholder="$t('SelectOpportunity')"
        v-model="filters.OpportunityId"
      >
        <vs-select-item
          v-for="(item, index) in opportunitiesOptions"
          :key="index"
          :value="item.Id"
          :text="currentLocale === 'ar' ? item.OpportunityNameAr : item.OpportunityNameEn" 
        />
      </vs-select>
    </div>

    <div class="vx-col lg:w-1/4 md:w-1/2 w-full mb-4">
      <label class="text-sm opacity-75">{{ $t("Property") }}</label>
      <vs-select 
        class="w-full mt-2" 
        :placeholder="$t('SelectProperty')"
        v-model="filters.PropertyId"
      >
        <vs-select-item
          v-for="(item, index) in propertiesOptions"
          :key="index"
          :value="item.Id"
          :text="currentLocale === 'ar' ? item.PropertyNameAr : item.PropertyNameEn" 
        />
      </vs-select>
    </div>

    <div class="vx-col lg:w-1/4 md:w-1/2 w-full mb-4">
      <label class="text-sm opacity-75">{{ $t("Status") }}</label>
      <vs-select 
        class="w-full mt-2" 
        :placeholder="$t('SelectStatus')"
        v-model="filters.TokenStatusId"
      >
        <vs-select-item
          v-for="(item, index) in statuses"
          :key="index"
          :value="item.Id"
          :text="currentLocale === 'ar' ? item.NameAr : item.NameEn" 
        />
      </vs-select>
    </div>

  </div>

  <div class="vx-row mt-2">
    <div class="vx-col flex flex-wrap gap-2">
      <!-- <vs-button color="primary" @click="applyFilters">{{ $t("ApplyFilters") }}</vs-button> -->
      <vs-button color="danger" type="border" @click="resetAll">{{ $t("ResetSearch") }}</vs-button>
    </div>
  </div>
</vx-card>
    <vs-table pagination :max-items="itemsPerPage" search :data="Tokens">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
         <h4 class="ml-4">{{ $t('TotalTokens') }}: {{ Tokens.length }}</h4>
      </div>

      <template slot="thead">
        <vs-th sort-key="TokenSerial">{{ $t("Serial") }}</vs-th>
        <vs-th sort-key="TokenSequenceNo">{{ $t("Seq") }}</vs-th>
        <vs-th>{{ $t("Opportunity") }}</vs-th>
        <vs-th>{{ $t("Status") }}</vs-th>
        <vs-th>{{ $t("Investor") }}</vs-th>
        <vs-th>{{ $t("PurchaseOrder") }}</vs-th>
        <vs-th>{{ $t("Actions") }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <tr v-for="(tr, indextr) in data" :key="indextr">
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.TokenSerial }}</p>
            </vs-td>
            <vs-td>{{ tr.TokenSequenceNo }}</vs-td>
            <vs-td>{{ tr.OpportunityName || 'OPP-' + tr.OpportunityId }}</vs-td>
           <vs-td>
               <vs-chip :color="getStatusColor(tr.TokenStatusId)">
                {{ getStatusName(tr.TokenStatusId) }}
              </vs-chip>
              </vs-td>
          <vs-td>
                <div v-if="tr.InvestorCode">
                    <p class="font-medium">{{ tr.InvestorCode }}</p>
                </div>
                <span v-else>-</span>
            </vs-td>

            <vs-td>
                <vs-chip v-if="tr.PurchaseOrderNumber" color="primary" transparent>
                    #{{ tr.PurchaseOrderNumber }}
                </vs-chip>
                <span v-else>-</span>
            </vs-td>
            <vs-td>
              <vx-tooltip text="View Details">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-10 h-5 hover:text-primary stroke-current"

                  @click.stop="openConfirm(tr)"
                />
              </vx-tooltip>
            </vs-td>
          </tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import moduleTokens from "@/store/Tokens/moduleTokens.js";
import moduleOpportunities from "@/store/Opportunities/moduleOpportunities.js";
import moduleOpportunityStatus from "@/store/OpportunityStatus/moduleOpportunityStatus.js";
import moduleProperties from "@/store/Properties/moduleProperties.js";
export default {
  data() {
    return {
      itemsPerPage: 10,
      keySearch: "",
      filters: {
        OpportunityId: null,
        PropertyId: null,
        TokenStatusId: null
      },
      searchTimer: null
    };
  },
watch: {
  keySearch() { this.debouncedSearch(); },
  filters: {
    handler() { this.debouncedSearch(); },
    deep: true
  }
},
  computed: {
      currentLocale() {
    return this.$i18n.locale;
  },
    Tokens() { return this.$store.state.TokensList.Tokens;},
    opportunitiesOptions() {return this.$store.state.OpportunitiesList.Opportunities; },
    statuses() { return this.$store.state.TokensList.TokenStatus; },
    propertiesOptions() {   return this.$store.state.PropertiesList.Properties; },
  },
  methods: {
    getStatusName(statusId) {
    const status = this.statuses.find(s => s.Id === statusId);
    
    if (status) {

      return this.currentLocale === 'ar' ? status.TokenStatusNameAr : status.TokenStatusNameEn;
    }
    return statusId;
  },

  getStatusColor(id) {

    if (id === 1) return "success"; 
    if (id === 2) return "danger"; 
    if (id === 3) return "warning"; 
    return "primary";
  },
       openConfirm(data) {
    
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Confirm Delete",
        accept: this.acceptAlert,
        acceptText: "Delete",
        cancelText: "Cancel",
      });
    },
    acceptAlert() {
      this.deleteData(this.rowDataForDelete);


      this.handleSearch(this.search);
    },
    deleteData(data) {
      this.$store.dispatch("TokensList/removeItem", data) .then((response) => {
        
      if (response && response.message && response.message.includes("Cannot delete Member")) {
        
        this.$vs.dialog({
          type: "alert",
          color: "danger",
          title: "Cannot Delete",
          text: response.message,
          acceptText: "OK",
        });
      } else {
      
        this.$store.dispatch("OpportunitiesList/fetchDataListItems");
        this.$vs.notify({
        color: "success",
        title: "Deleted record",
        text: this.$t("DeletedSuccessfully"),
      });
      }
    })
    .catch((err) => {
        console.error(err);
        let errorMessage = "An error occurred while deleting the Member.";
        
        if (err.response && err.response.data && err.response.data.message) {
          errorMessage = err.response.data.message;
        }
        
        this.$vs.dialog({
          type: "alert",
          color: "danger",
          title: "Error",
          text: errorMessage,
          acceptText: "OK",
        });
        
        this.$store.dispatch("OpportunitiesList/fetchDataListItems");
      });
    },
   debouncedSearch() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.applyFilters();
    }, 500);
  },
  applyFilters() {
    const payload = {
      Serial: this.keySearch,
      ...this.filters
    };
    this.$store.dispatch("TokensList/fetchFilteredTokens", payload);
  },
    resetAll() {
      this.keySearch = "";
      this.filters = { OpportunityId: null, PropertyId: null, TokenStatusId: null };
      this.applyFilters();
    },
 
  },
  created() {
    if (!moduleTokens.isRegistered) {
      this.$store.registerModule("TokensList", moduleTokens);
      moduleTokens.isRegistered = true;
    }
        this.$store.dispatch("TokensList/fetchTokens");
        this.$store.dispatch("TokensList/fetchTokenStatus");


    this.applyFilters();

     if (!moduleOpportunities.isRegistered) {
      this.$store.registerModule("OpportunitiesList", moduleOpportunities);
      moduleOpportunities.isRegistered = true;
    }
      this.$store.dispatch("OpportunitiesList/fetchDataListItems");

       if (!moduleProperties.isRegistered) {
      this.$store.registerModule("PropertiesList", moduleProperties);
      moduleProperties.isRegistered = true;
    } 
    this.$store.dispatch("PropertiesList/fetchDataListItems");


     if (!moduleOpportunityStatus.isRegistered) {
      this.$store.registerModule("OpportunityStatusList", moduleOpportunityStatus);
      moduleOpportunityStatus.isRegistered = true;
    } 

    this.$store.dispatch("OpportunityStatusList/fetchDataListItems");
    
  }
};
</script>

<style lang="scss">

 .icon-container{
    display: flex;
  }
#data-list-list-view small {
  color: rgb(255, 115, 0);
  text-decoration: underline rgb(255, 115, 0);
}

.vxCard:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0%;
  margin-left: 10%;
  z-index: 500000;
  width: 25%;
  height: 20%;
  border-top: 3px solid rgb(255, 115, 0) !important;
  border-bottom: 0 none rgba(255, 0, 0, 0.9) !important;
  border-right: 0 none rgba(255, 0, 0, 0.9) !important;
  border-left: 0 none rgba(0, 0, 0, 0.9) !important;
}
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }

    .btn{
      margin-top: 5%;
    }
  }
}
</style>
